import Oppsummering from "./Oppsummering";
import { Organisasjonsnummer } from "../Organisasjonsnummer/Organisasjonsnummer";
import Translated from "../infrastructure/translation/Translated";
import { useManuellRegistreringContext } from "../ManuellRegistreringsflyt/useManuellRegistreringContext";
import { SummaryPoint } from "./OppsummeringBody";

export function ManuellRegistreringsflytOppsummering() {
  const { kontaktInfo, integrasjonsPartner, registrer, previousStep, reset } =
    useManuellRegistreringContext();

  if (!kontaktInfo) {
    return reset();
  }

  const summaryPoints = [
    {
      headerKey: "generic.business",
      values: [
        kontaktInfo.orgName,
        <Organisasjonsnummer orgNr={kontaktInfo.orgNumber} />,
        kontaktInfo.companyEmail,
      ],
    },
    integrasjonsPartner
      ? {
          headerKey: "partneronboarding.system_provider",
          values: [
            integrasjonsPartner.orgName,
            <Organisasjonsnummer orgNr={integrasjonsPartner.orgNumber} />,
          ],
        }
      : undefined,
    {
      headerKey: "generic.name",
      values: [`${kontaktInfo.firstName} ${kontaktInfo.lastName}`],
    },
    {
      headerKey: "contact.email_personal",
      values: [kontaktInfo.personalEmail],
    },
    {
      headerKey: "summary.comment",
      values: [
        kontaktInfo.comment?.length ? (
          kontaktInfo.comment
        ) : (
          <Translated textKey={"summary.none"} />
        ),
      ],
    },
  ].filter((p) => p !== undefined) as SummaryPoint[];

  return (
    <Oppsummering
      goBack={previousStep}
      submitAction={registrer}
      submitTextKey="summary.register_button"
      summaryPoints={summaryPoints}
      showTermsCheckbox={!integrasjonsPartner}
    />
  );
}
